export default __webpack_public_path__ + "static/media/tudasbazis.5f933981.png";